import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { TripSettingsRouteName } from '@pages/settings-page/settings-route-names';

export const tripMenuItemTitle = 'Settings.Trips';

export const tripMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.Trips.Expenses',
    routerLink: TripSettingsRouteName.Expenses,
    permissions: [RolesAndPermissions.TripExpenseSettingsRead],
  },
  {
    label: 'Settings.Trips.FuelPrices',
    routerLink: TripSettingsRouteName.FuelPrices,
    permissions: [RolesAndPermissions.TripFuelSettingsRead],
  },
  {
    label: 'Settings.Trips.TripTypeSetup',
    routerLink: TripSettingsRouteName.TripTypeSetup,
    permissions: [RolesAndPermissions.TripSettingsTypeSetupRead],
  },
  {
    label: 'Settings.Trips.VismaPayroll',
    routerLink: TripSettingsRouteName.VismaPayroll,
  },
];
